import { createReducer, on } from '@ngrx/store';
import { DeliveryRequestState } from '../../models/delivery-request-state.model';
import { DeliveryResponseState } from '../../models/delivery-response-state.model';
import * as serviceActions from '../actions/delivery-requests.action';
import { DeliveryRequest } from '../../models/delivery-request.model';
import { Action } from 'rxjs/internal/scheduler/Action';

export const initialRequestState: DeliveryRequestState = {
  requests: [],
  service: null,
  error: null,
  isLoading: false,
  page: 1,
  totalItems: 0,
  totalPages: 0,
};



export const requestReducer = createReducer(
  initialRequestState,

  on(serviceActions.createService, (state)=> ({
    ...state,
    isLoading: true,
  })),

  on(serviceActions.createServiceSuccess, (state, action) => ({
    ...state,
    service: null,
    requests: [...state.requests, action.service],
    isLoading: false,
  })),

  on(serviceActions.createServiceFailure, (state, action) => ({
    ...state,
    error: action.error,
    service: null,
    isLoading: false,
  })),
  on(serviceActions.editService, (state, action) => ({
    ...state,
    isLoading: true,
  })),
  on(serviceActions.editServiceSuccess, (state, action) => ({
    ...state,
    service: action.service,
    requests: [...state.requests, action.service],
    isLoading: false,
  })),
  on(serviceActions.editServiceFailure, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  })),
  
  on(serviceActions.loadServices, (state) => {
   return {...state, isLoading: true}
  }),
  on(serviceActions.loadServicesSuccess, (state, { services }) => { 
   return {
    ...state,
    requests: services.items,
    page: services.page,
    totalItems: services.total_items,
    totalPages: services.total_pages,
    isLoading: false,
   } 
  }),

  on(serviceActions.loadServicesFailure, (state, action) => {
   return {
    ...state,
    error: action.error,
    isLoading: false
    }
  }),
 


  on(serviceActions.updateService, (state, action) => ({
    ...state,
    service: action.service,
  })),

  on(serviceActions.assignDeliveryRequest, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(serviceActions.assignDeliveryRequestSuccess, (state, action) => ({
    ...state,
    service: action.service,
    isLoading: false,
  })),
  on(serviceActions.assignDeliveryRequestFailure, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  })),
);



